import axios from '@config/axios-config';
import { IApiResponse } from '@datatype/common/api-type';
import {
  IModifyShelfRequest,
  IModifySubscriptionRequest,
  ISubscriptionData,
  IShelfData,
  IProviderData,
  ICategoryData,
  IArticleData,
} from '@datatype/moashelf/api-type';
import { IMoashelfMenu } from '@datatype/moashelf/type';

// 나의 shelf 목록 조회 api
export const getMyShelves = async ({
  page,
  perPage,
  mode,
}: {
  page: number;
  perPage: number;
  mode: IMoashelfMenu['shelf'];
}): Promise<IApiResponse<IShelfData[]>> => {
  let endpoint = `/api/v1/newsletter/me/shelf?page=${page}&perPage=${perPage}`;

  switch (mode) {
    case 'shelf-all':
      break;
    case 'shelf-bookmark':
      endpoint += '&isBookmark=true';
      break;
    case 'shelf-unread':
      endpoint += '&isRead=false';
      break;
    case 'shelf-trash':
      endpoint += '&isTrash=true';
      break;
    default:
      break;
  }
  const response = await axios.get<IApiResponse<IShelfData[]>>(endpoint).then((res) => res.data);
  return response;
};

// shelf 단건 조회 api
export const getShelf = async (shelfKey: string): Promise<IApiResponse<IShelfData>> => {
  const response = await axios
    .get<IApiResponse<IShelfData>>(`/api/v1/newsletter/shelf/${shelfKey}`)
    .then((res) => res.data);

  return response;
};

// shelf 수정 api
export const modifyShelf = async (request: IModifyShelfRequest): Promise<IApiResponse<IShelfData>> => {
  const { shelfKey, isRead, isBookmark, isTrash, isPurge, hashtag } = request;
  const body = { isRead, isBookmark, hashtag, isTrash, isPurge };

  const response = await axios
    .patch<IApiResponse<IShelfData>>(`/api/v1/newsletter/shelf/${shelfKey}`, body)
    .then((res) => res.data);

  return response;
};

// article 단건 조회 api
export const getArticle = async (articleKey: string): Promise<IApiResponse<IArticleData>> => {
  const response = await axios
    .get<IApiResponse<IArticleData>>(`/api/v1/newsletter/article/${articleKey}`)
    .then((res) => res.data);

  return response;
};

// 나의 subscription 목록 조회 api
export const getMySubscriptions = async ({
  page,
  perPage,
  mode,
}: {
  page: number;
  perPage: number;
  mode: IMoashelfMenu['subscription'];
}): Promise<IApiResponse<ISubscriptionData[]>> => {
  let endpoint = `/api/v1/newsletter/me/subscription?page=${page}&perPage=${perPage}`;

  switch (mode) {
    case 'subscription-all':
      break;
    case 'subscription-bookmark':
      endpoint += '&isBookmark=true';
      break;
    case 'subscription-trash':
      endpoint += '&isTrash=true';
      break;
    default:
      break;
  }

  const response = await axios.get<IApiResponse<ISubscriptionData[]>>(endpoint).then((res) => res.data);
  return response;
};

// 나의 subscription 목록 조회 api
export const getCategories = async ({
  page,
  perPage,
}: {
  page: number;
  perPage: number;
}): Promise<IApiResponse<ICategoryData[]>> => {
  const endpoint = `/api/v1/newsletter/category?page=${page}&perPage=${perPage}`;
  const response = await axios.get<IApiResponse<ICategoryData[]>>(endpoint).then((res) => res.data);
  return response;
};

// provier 목록 조회 api
export const getProviders = async ({
  page,
  perPage,
  categoryKey,
}: {
  page: number;
  perPage: number;
  categoryKey: string | null;
}): Promise<IApiResponse<IProviderData[]>> => {
  let endpoint = `/api/v1/newsletter/provider?page=${page}&perPage=${perPage}&sort=popular`;

  if (categoryKey) {
    endpoint += `&categoryKeys=${categoryKey}`;
  }

  const response = await axios.get<IApiResponse<IProviderData[]>>(endpoint).then((res) => res.data);
  return response;
};

// article 목록 조회 api
export const getArticles = async ({
  page,
  perPage,
  categoryKey,
}: {
  page: number;
  perPage: number;
  categoryKey: string | null;
}): Promise<IApiResponse<IArticleData[]>> => {
  let endpoint = `/api/v1/newsletter/article?page=${page}&perPage=${perPage}&sort=popular`;

  if (categoryKey) {
    endpoint += `&categoryKeys=${categoryKey}`;
  }

  const response = await axios.get<IApiResponse<IArticleData[]>>(endpoint).then((res) => res.data);
  return response;
};

// subscription 수정 api
export const modifySubscription = async (
  request: IModifySubscriptionRequest,
): Promise<IApiResponse<ISubscriptionData>> => {
  const { subscriptionKey, isBookmark, isTrash, isPurge } = request;
  const body = { isBookmark, isTrash, isPurge };

  const response = await axios
    .patch<IApiResponse<ISubscriptionData>>(`/api/v1/newsletter/subscription/${subscriptionKey}`, body)
    .then((res) => res.data);

  return response;
};
